import { authHeader } from '../helpers';

export const commonService = {
    getTimeZoneListData,
    removeTmpImage,
    removeImageByName,
    setDefaultImage
};

function getTimeZoneListData() {
    const requestOptions = {
        method: "GET",
        headers: {"Content-Type": "application/json"}
    };
    const apiUrl = process.env.VUE_APP_MIX_URL;

    return fetch(
        `${apiUrl}/admin/get_time_zone`,
        requestOptions
    )
        .then(handleResponse)
        .then(response => {
            if (response.success) {
                return response;
            } else {
                return [];
            }

        });
}

function removeImageByName(file, path) {
    // let formData = new FormData();
    // formData.append('file', file);
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({file})
    };
    //const apiUrl = process.env.MIX_API_URL;
    return fetch(`${path}`, requestOptions)
        .then(handleResponse)
        .then(res => {
            return res;
        });
}

function setDefaultImage(file) {
    const requestOptions = {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({file: file})
    };
    const apiUrl = process.env.VUE_APP_MIX_URL;
    return fetch(`${apiUrl}/admin/category/defaul_image`, requestOptions)
        .then(handleResponse)
        .then(res => {
           return res;
        });
}

function removeTmpImage(file) {
    // const requestOptions = {
    //     method: "POST",
    //     headers: { "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content  },
    //     body: JSON.stringify({ file: file })
    // };
    const requestOptions = {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({file: file})
    };
    const apiUrl = process.env.VUE_APP_MIX_URL;
    return fetch(`${apiUrl}/admin/remove-temp-image`, requestOptions)
        .then(handleResponse)
        .then(res => {
            // login successful if there's a jwt token in the response
            if (res.data) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                // localStorage.setItem("user", JSON.stringify(res.data));
            }
            return res;
        });
}

// function removeTmpImage() {
//     const requestOptions = {
//         method: "GET",
//         headers: { "Content-Type": "application/json" }
//     };
//     const apiUrl = process.env.MIX_API_URL;

//     return fetch(
//         `${apiUrl}/admin/get_time_zone`,
//         requestOptions
//     )
//         .then(handleResponse)
//         .then(response => {
//             if (response.success) {
//                 return response;
//             }
//             else{
//                 return [];
//             }

//         });
// }

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                //logout();
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
